module.exports = __webpack_public_path__ + "img/android-qrcode-overlay-tuto.84dc4ef7.webp";